<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import {usePage} from "@inertiajs/vue3";
import {getArrSortsReview} from "@/constants.js";
import {ref} from "vue";
import UserCard from "@/Pages/User/Components/UserCard.vue";
import Card from "@/Components/Card.vue";
import Lots from "@/Pages/User/Components/Lots.vue";

const page = usePage(),
    user = page.props.user,
    selectFilter = ref(getArrSortsReview()[0]),
    lotsCount = ref(page.props.lots.total),
    pageTitle = user.name

const setSelectedFilter = (selectedFilter) => {
    selectFilter.value = selectedFilter
}

</script>

<template>
    <AppLayout :title="pageTitle">
        <div class="flex flex-col max-w-[48.75rem] m-auto gap-2.5">
            <UserCard @set-selected-filter="setSelectedFilter" :selected-filter="[]"  />
            <Lots v-if="lotsCount > 0"/>
            <Card v-else class="px-3 py-5">
                <div class="px-2.5 dark:text-slate-200 text-sm font-semibold leading-120">
                    {{$t('No offers yet.')}}
                </div>
            </Card>
        </div>
    </AppLayout>
</template>

<style scoped>

</style>
